<template>
  <edit-role />
</template>

<script>
// import EditRole from "@/components/3pl/Settings/RolesAndPrivileges/EditRole/index";
export default {
  components: {
    // EditRole,
  },
};
</script>

<style></style>
